export enum PurchaseOrderStatus {
  DRAFT = "DRAFT",
  CONFIRMED = "CONFIRMED",
  PARTIALLY_RECEIVED = "PARTIALLY_RECEIVED",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
  /** @deprecated Older API — map in UI */
  SENT = "SENT",
  RECEIVED = "RECEIVED",
  CLOSED = "CLOSED",
}

export const PurchaseOrderStatusMap: Record<
  string,
  { label: string; color: string }
> = {
  [PurchaseOrderStatus.DRAFT]: {
    label: "Draft",
    color: "secondary",
  },
  [PurchaseOrderStatus.CONFIRMED]: {
    label: "Confirmed",
    color: "info",
  },
  /** @deprecated legacy rows migrated to CONFIRMED */
  APPROVED: {
    label: "Confirmed",
    color: "info",
  },
  [PurchaseOrderStatus.PARTIALLY_RECEIVED]: {
    label: "Partially received",
    color: "warning",
  },
  [PurchaseOrderStatus.COMPLETED]: {
    label: "Completed",
    color: "success",
  },
  [PurchaseOrderStatus.CANCELLED]: {
    label: "Cancelled",
    color: "danger",
  },
  [PurchaseOrderStatus.SENT]: {
    label: "Sent",
    color: "primary",
  },
  [PurchaseOrderStatus.RECEIVED]: {
    label: "Received",
    color: "success",
  },
  [PurchaseOrderStatus.CLOSED]: {
    label: "Closed",
    color: "dark",
  },
};

export function purchaseOrderCanEdit(status: string): boolean {
  return status === PurchaseOrderStatus.DRAFT;
}

export function purchaseOrderCanConfirm(status: string): boolean {
  return status === PurchaseOrderStatus.DRAFT;
}

export function purchaseOrderCanReceive(status: string): boolean {
  return (
    status === PurchaseOrderStatus.CONFIRMED ||
    status === PurchaseOrderStatus.PARTIALLY_RECEIVED
  );
}

/** Cancel: only allowed from DRAFT — once confirmed, MRs are completed and cannot be undone. */
export function purchaseOrderCanCancel(status: string): boolean {
  return status === PurchaseOrderStatus.DRAFT;
}
